
import { defineComponent } from "vue";

import GcuLink from "@/components/gcuLink.vue";
import RGPDLink from "@/components/RGPDLink.vue";
import colors from "@/styles/colors";
import { mapState } from "vuex";
import { State } from "@/store";

import { QrCodeTypes } from "@/models/QrCodeObject";

import MultiVideoProjectSuccess from "./success/MultiVideoProjectSuccess.vue";
import StandardProjectSuccess from "./success/StandardProjectSuccess.vue";

export default defineComponent({
    name: "Success",
    components: {
        RGPDLink,
        GcuLink,
        MultiVideoProjectSuccess,
        StandardProjectSuccess
    },
    data() {
        return {
            colors,
            QrCodeTypes: QrCodeTypes
        };
    },
    computed: {
        ...mapState({
            logoB64: (state: State) => state.qrcode.logoB64,
            qrcodeObject: (state: State) => state.qrcode.qrcodeObject
        })
    },
    methods: {
        goAr() {
            let permissionPromise;

            if (typeof DeviceMotionEvent.requestPermission === "function") {
                permissionPromise = DeviceMotionEvent.requestPermission();
            } else {
                permissionPromise = Promise.resolve("granted");
            }

            permissionPromise.then(response => {
                if (response === "granted") {
                    this.$router.replace("AR");
                } else {
                    this.$router.replace("/");
                }
            });
        }
    }
});
